<template>
  <div class="link_container">
    <span
      v-for="(filter, index) in filters"
      :key="index"
      class="link"
      :class="{
        'gold--text': activeFilter !== index,
        'selected--text': activeFilter === index
      }"
      @click.stop="filterClicked(filter.value, index)"
    >
      {{ filter.name }}
      {{ filter.divider }}</span>
  </div>
</template>
<script>
export default {
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeFilter: 0,
      selectedFilter: 'all'
    }
  },
  methods: {
    filterClicked(value, index) {
      this.activeFilter = index
      this.$emit('filter-clicked', value)
    }
  }
}
</script>
<style lang="sass">
.link
  color: $hwayzBrandGold
  font-size: 1.5rem
  cursor: pointer
.selected--text
  color: $hwayzBrandBlue
</style>
